import { getBooleanFeatureFlag } from '@atlassian/jira-portfolio-3-common/src/feature-flags/utils.tsx';

const isPollinatorTenant = () => getBooleanFeatureFlag('jsw.pollinator.tenants');

export default isPollinatorTenant;
